module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_3-00da06c9f528c7afafa6f15555f4f9a1.jpg";